import { render } from "./AuthLayout.vue?vue&type=template&id=01f2c77e&scoped=true&ts=true&lang=pug"
import script from "./AuthLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&setup=true&lang=ts"

import "./AuthLayout.vue?vue&type=style&index=0&id=01f2c77e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f2c77e"]])

export default __exports__